'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import AppShell from '@components/ui/app-shell'
import PageHeader from '@components/ui/page-header'
import MemberFollowUpDashboard from './member-follow-up-dashboard.web'
import MemberNeedsAttention from './members-needs-attention.web'
import MemberSavingsDashboard from './member-savings-dashboard.web'

/* -----------------------------------------------------------------------------
 * Home
 *
 * NOTE: titled "Reports" so it no longer collides with the clinical dashboard
 * at /dashboard.
 * -------------------------------------------------------------------------- */

function Home() {
  return (
    <AppShell activePage='home' label='Home'>
      <PageHeader eyebrow='Clinical operations' title='Reports' />

      <MemberNeedsAttention />
      <MemberFollowUpDashboard />
      <MemberSavingsDashboard />
    </AppShell>
  )
}

export default Home
